import React, { Component } from 'react'
import { apiDashboard } from 'helpers/decorators/api'
import EditProfileInner from './EditProfileInner'

@apiDashboard.apiPersons({
    loadProfile: true,
})
class EditProfileParticipant extends Component {
  render() {
    return (
      <EditProfileInner {...this.props} />
    )
  }
}

export default EditProfileParticipant
